import { get as getSelectedProject } from 'serviceWorker/db/selectedProject';
import { Fetcher } from 'serviceWorker/services/httpQueue/fetcher';

export type ApiMethod = 'GET' | 'POST' | 'PUT' | 'DELETE';

export interface ApiRequest {
  method: ApiMethod;
  /** Path after `/v2/`, e.g. `user/me`. */
  path: string;
  body?: unknown;
  /** `text` for a GET answered with text instead of JSON. */
  responseType?: 'json' | 'text';
}

/**
 * Calls the API at once, not through the HTTP queue: for reads and for
 * changes whose result the page needs right away. Uses the worker's token
 * and headers; rejects with an HttpError carrying the server's message, so
 * the page gets its `messageId`.
 */
export function requestApi<TResponse>({ method, path, body, responseType }: ApiRequest): Promise<TResponse> {
  switch (method) {
    case 'GET':
      return responseType === 'text' ? (Fetcher.GET_TEXT(path) as Promise<TResponse>) : Fetcher.GET(path);
    case 'POST':
      return Fetcher.POST(path, body);
    case 'PUT':
      return Fetcher.PUT(path, body);
    case 'DELETE':
      return Fetcher.DELETE(path);
  }
}

/** `requestApi` under the selected project: `path` is relative to `/v2/project/{projectId}/`. */
export async function requestProjectApi<TResponse>(request: ApiRequest): Promise<TResponse> {
  const project = await getSelectedProject();
  if (!project) {
    throw new Error(`Cannot call ${request.method} ${request.path}: no project is selected`);
  }
  return requestApi({ ...request, path: `project/${project._id}/${request.path}` });
}
